export default __webpack_public_path__ + "static/media/calibri.b280ca11.ttf";